import { analysisVersion1 } from './analysis-version-1'

// Nová verzia dotazníka = nový priečinok `analysis-version-N` + záznam tu.
// Vyplnený dotazník sa posiela do API spolu s verziou, podľa ktorej vznikol.
const investorAnalysisVersions = {
  '1': analysisVersion1,
}

type InvestorAnalysisVersion = keyof typeof investorAnalysisVersions

function isInvestorAnalysisVersion(
  version: string | undefined
): version is InvestorAnalysisVersion {
  return !!version && version in investorAnalysisVersions
}

export function getInvestorAnalysisVersion() {
  const version = import.meta.env.VITE_ONBOARDING_INVESTOR_ANALYSIS_VERSION
  if (!isInvestorAnalysisVersion(version)) {
    throw new Error(`Unknown investor analysis version: ${version}`)
  }
  return { version, ...investorAnalysisVersions[version] }
}
